import React, { Component } from 'react';
import PropTypes from 'prop-types'


import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";

// import testData from './testData.json';
// import transcribeData from './transcriptData.json';

import 'rc-slider/assets/index.css';
import BeatLoader from "react-spinners/BeatLoader";
//import { ConsoleLogger } from '@aws-amplify/core';



class Image extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cropperRef: null,
      previewUrl: null,
      naturalHeight: null,
      naturalWidth: null,
      aspectRatio: null,
      cropWidth: null,
      cropHeight: null,
      cropX: null,
      cropY: null
    }
  }




  componentDidMount() {
  }
  croppEnd() {
    let cropperRef = this.state.cropperRef
    let imageData = cropperRef.getCroppedCanvas().toDataURL()
    let base64 = `url(data:image/png;base64,${imageData.replace("data:image/png;base64,", "")})`
    this.setState({ imageData: base64 })
    console.log({ imageData })
  }

  setStuff() {
    console.log("i'm doing stuff")
    let imageData = window.cropperRef.imageData
    let cropData = window.cropperRef.getData()
    console.log({ cropData })
    if (cropData && cropData.width) {
      this.setState({ cropWidth: Math.trunc(cropData.width), cropHeight: Math.trunc(cropData.height), cropX: cropData.x, cropY: cropData.y })
    }

    this.setState({ naturalWidth: imageData.naturalWidth, naturalHeight: imageData.naturalHeight })
  }



  render() {
    console.log({ renderLog: this.state.naturalHeight })
    return (
      <div>
        <Cropper
          src={window.OriginalWithSecret}
          style={{ height: 800, width: "70%" }}
          // Cropper.js options
          autoCrop={true}
          movable={true}
          guides={true}
          preview=".img-preview"
          scalable={false}
          zoomable={false}
          zoomOnWheel={false}
          zoomTo={0.5}
          ref={window.cropperRef}
          ready={this.setStuff.bind(this)}
          cropend={this.setStuff.bind(this)}
          autoCropArea={1}
          //  viewMode={0}
          aspectRatio={"none"}
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          checkCrossOrigin={false}
          onLoad={() => alert("image loaded")}
          onInitialized={(instance) => {
            console.log({ instance })

            this.state.cropperRef = instance;

            window.setImageData = this.setStuff.bind(this)

            window.cropperRef = instance;
            this.setStuff(instance)
          }}
        />
        <h1>Image Size: {this.state.naturalHeight}x{this.state.naturalWidth}</h1>
        <h1>Crop Size: {this.state.cropHeight}x{this.state.cropWidth}, X: {this.state.cropX},  Y: {this.state.cropY}</h1>
      </div>

    )
  }

}



Image.propTypes = {
  data: PropTypes.object,
};

export default Image